/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_ScheduleInputs */

const th_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูตารางแข่ง →`)
};

const en_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View schedule →`)
};

const ja_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日程を見る →`)
};

const zh_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看赛程 →`)
};

const es_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver calendario →`)
};

const pt_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver calendário →`)
};

const id_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat jadwal →`)
};

const fr_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir le calendrier →`)
};

const tl_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingnan ang iskedyul →`)
};

const vi_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem lịch thi đấu →`)
};

const ko_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일정 보기 →`)
};

const de_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielplan ansehen →`)
};

const ru_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смотреть расписание →`)
};

const tr_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fikstürü gör →`)
};

const it_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi il calendario →`)
};

const pl_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz terminarz →`)
};

const uk_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дивитися розклад →`)
};

const hi_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम देखें →`)
};

const ar_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض الجدول ←`)
};

const ms_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat jadual →`)
};

const bn_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সূচি দেখুন →`)
};

const zh_tw2_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看賽程 →`)
};

const zh_hk2_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看賽程 →`)
};

const ur_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شیڈول دیکھیں ←`)
};

const fa_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دیدن برنامه ←`)
};

const sw_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ona ratiba →`)
};

const nl_view_schedule = /** @type {(inputs: View_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema bekijken →`)
};

/**
* | output |
* | --- |
* | "View schedule →" |
*
* @param {View_ScheduleInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const view_schedule = /** @type {((inputs?: View_ScheduleInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_ScheduleInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_view_schedule(inputs)
	if (locale === "ja") return ja_view_schedule(inputs)
	if (locale === "zh") return zh_view_schedule(inputs)
	if (locale === "es") return es_view_schedule(inputs)
	if (locale === "pt") return pt_view_schedule(inputs)
	if (locale === "id") return id_view_schedule(inputs)
	if (locale === "fr") return fr_view_schedule(inputs)
	if (locale === "tl") return tl_view_schedule(inputs)
	if (locale === "vi") return vi_view_schedule(inputs)
	if (locale === "ko") return ko_view_schedule(inputs)
	if (locale === "de") return de_view_schedule(inputs)
	if (locale === "ru") return ru_view_schedule(inputs)
	if (locale === "tr") return tr_view_schedule(inputs)
	if (locale === "it") return it_view_schedule(inputs)
	if (locale === "pl") return pl_view_schedule(inputs)
	if (locale === "uk") return uk_view_schedule(inputs)
	if (locale === "hi") return hi_view_schedule(inputs)
	if (locale === "ar") return ar_view_schedule(inputs)
	if (locale === "ms") return ms_view_schedule(inputs)
	if (locale === "bn") return bn_view_schedule(inputs)
	if (locale === "zh-TW") return zh_tw2_view_schedule(inputs)
	if (locale === "zh-HK") return zh_hk2_view_schedule(inputs)
	if (locale === "ur") return ur_view_schedule(inputs)
	if (locale === "fa") return fa_view_schedule(inputs)
	if (locale === "sw") return sw_view_schedule(inputs)
	if (locale === "nl") return nl_view_schedule(inputs)
	return en_view_schedule(inputs)
});